export default {"src":"/_next/static/media/VAlvesIconWhite.62176428.svg","height":70,"width":99};